import { useState } from 'react';
import './index.css';
import { useStore } from './hooks/useStore';
import { Sidebar } from './components/Sidebar';
import { AddExpenseModal } from './components/AddExpenseModal';
import { AddGroupModal } from './components/AddGroupModal';
import { SettleUpModal } from './components/SettleUpModal';
import { Dashboard } from './pages/Dashboard';
import { GroupView } from './pages/GroupView';
import { FriendsPage, ActivityPage } from './pages/OtherPages';

const ME_ID = 1; // "You" is always person #1

export default function App() {
  const store = useStore();
  const [view, setView] = useState('dashboard');
  const [groupId, setGroupId] = useState(null);
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [showAddGroup, setShowAddGroup] = useState(false);
  const [showSettle, setShowSettle] = useState(false);

  if (store.loading) return <div className="loading">Loading…</div>;
  if (store.error) return <div className="loading" style={{ color: 'var(--red)' }}>Error: {store.error}</div>;

  const currentGroup = store.groups.find(g => g.id === groupId);

  const handleNav = (v) => { setView(v); setGroupId(null); };
  const handleGroupNav = (id) => { setGroupId(id); setView('group'); };

  const handleAddGroup = async (data) => {
    const g = await store.addGroup(data);
    setGroupId(g.id); setView('group');
  };

  const handleSettle = async (data) => {
    await store.addSettlement(data);
  };

  let title = view === 'dashboard' ? 'Dashboard' : view === 'friends' ? 'Friends' : view === 'activity' ? 'Activity' : '';
  if (currentGroup) title = currentGroup.name;

  return (
    <div className="app">
      <Sidebar
        groups={store.groups}
        view={view}
        groupId={groupId}
        onNav={handleNav}
        onGroupNav={handleGroupNav}
        onAddGroup={() => setShowAddGroup(true)}
      />

      <div className="main">
        <div className="topbar">
          <div className="topbar-title">{title}</div>
          <div className="topbar-actions">
            <button className="btn" onClick={() => setShowSettle(true)}>⇄ Settle up</button>
            <button className="btn btn-primary" onClick={() => setShowAddExpense(true)}>＋ Add expense</button>
          </div>
        </div>

        {view === 'dashboard' && (
          <Dashboard
            people={store.people} groups={store.groups}
            expenses={store.expenses} balances={store.balances}
            meId={ME_ID}
            onDeleteExpense={store.deleteExpense}
            onSettle={handleSettle}
          />
        )}
        {view === 'group' && currentGroup && (
          <GroupView
            group={currentGroup} people={store.people}
            expenses={store.expenses} balances={store.balances}
            meId={ME_ID}
            onDeleteExpense={store.deleteExpense}
            onSettle={handleSettle}
          />
        )}
        {view === 'friends' && (
          <FriendsPage people={store.people} balances={store.balances} meId={ME_ID} />
        )}
        {view === 'activity' && (
          <ActivityPage expenses={store.expenses} people={store.people} groups={store.groups} />
        )}
      </div>

      {showAddExpense && (
        <AddExpenseModal
          groups={store.groups} people={store.people}
          defaultGroupId={groupId}
          onSave={store.addExpense}
          onClose={() => setShowAddExpense(false)}
        />
      )}
      {showAddGroup && (
        <AddGroupModal
          people={store.people}
          onSave={handleAddGroup}
          onClose={() => setShowAddGroup(false)}
        />
      )}
      {showSettle && (
        <SettleUpModal
          balances={store.balances} people={store.people} meId={ME_ID}
          onSettle={handleSettle}
          onClose={() => setShowSettle(false)}
        />
      )}
    </div>
  );
}
